import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const buyers = [{
  name: 'Valentina M.',
  city: 'Córdoba',
  product: 'el Megakit Más Clientas',
  time: '2 minutos'
}, {
  name: 'Florencia B.',
  city: 'Buenos Aires',
  product: 'el Megakit Más Clientas',
  time: '5 minutos'
}, {
  name: 'Camila R.',
  city: 'Rosario',
  product: 'el Megakit Más Clientas',
  time: '3 minutos'
}, {
  name: 'Sofía M.',
  city: 'Mendoza',
  product: 'el Megakit Más Clientas',
  time: '1 minuto'
}, {
  name: 'Paula G.',
  city: 'Tucumán',
  product: 'el Megakit Más Clientas',
  time: '4 minutos'
}];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 10000);
    // Cycle every 45 seconds
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setBuyerIndex(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing next
      // Auto hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 7000);
    }, 45000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [isDismissed]);
  if (isDismissed) return null;
  const buyer = buyers[buyerIndex];
  return <AnimatePresence data-id="element-367" data-mp="x6m4pfe7ur1m">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-24 md:bottom-8 left-4 md:left-8 z-50 bg-white rounded-xl shadow-lg border border-gray-100 p-4 max-w-xs flex gap-4 items-start" data-id="element-368" data-mp="s5onb5116116">
          <button onClick={() => {
        setIsVisible(false);
        setIsDismissed(true);
      }} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-369" data-mp="2kn0n5s3lcd15">
            <X size={16} data-id="element-370" data-mp="1ryv3z9s6qw3f" />
          </button>

          <div className="text-2xl mt-1" data-id="element-371" data-mp="1rvz4hh0ovzcv">💅</div>
          <div data-id="element-372" data-mp="1wwdeh4lupjdj">
            <p className="text-xs text-gray-500 font-montserrat font-semibold uppercase tracking-wider mb-1" data-id="element-373" data-mp="1wxy72oolus8r">
              Compra verificada
            </p>
            <p className="text-sm font-montserrat text-dark" data-id="element-374" data-mp="26mpv4lqjosee">
              <strong data-id="element-375" data-mp="26oaq2cgrudcs">{buyer.name}</strong> de {buyer.city} compró{' '}
              {buyer.product} hace {buyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};